import React from 'react';
import './DatePriceExplorer.css';

/**
 * DatePriceExplorer Component
 * 
 * Shows nearby dates with prices to help find cheaper options
 */
const DatePriceExplorer = ({ selectedDate, onDateSelect }) => {
  
  // Generate date options (3 days before and after selected date)
  const generateDateOptions = () => {
    if (!selectedDate) return [];
    
    const selected = new Date(selectedDate);
    const options = [];
    
    for (let i = -3; i <= 3; i++) {
      const date = new Date(selected);
      date.setDate(selected.getDate() + i);
      
      // Mock prices - in real app, fetch from API
      const basePrice = 225;
      const variance = Math.floor(Math.random() * 50) - 25;
      const price = basePrice + variance;
      const savings = i === 0 ? 0 : Math.max(0, basePrice - price);
      
      options.push({
        date: date.toISOString().split('T')[0],
        displayDate: date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }),
        dayLabel: i === -3 ? '3d earlier' : 
                  i === -2 ? '2d earlier' :
                  i === -1 ? '1d earlier' :
                  i === 0 ? 'Selected' :
                  i === 1 ? '1d later' :
                  i === 2 ? '2d later' : '3d later',
        price,
        savings,
        isSelected: i === 0
      });
    }
    
    return options;
  };

  const dateOptions = generateDateOptions();

  if (dateOptions.length === 0) return null;

  return (
    <div className="date-price-explorer">
      <div className="explorer-header">
        <span className="explorer-icon">📅</span>
        <span className="explorer-title">Explore Cheaper Dates</span>
        <span className="explorer-subtitle">Prices may vary on nearby dates</span>
      </div>

      <div className="date-options">
        {dateOptions.map((option) => (
          <button
            key={option.date}
            className={`date-option ${option.isSelected ? 'selected' : ''}`}
            onClick={() => !option.isSelected && onDateSelect && onDateSelect(option.date)}
          >
            <div className="date-label">{option.dayLabel}</div>
            <div className="date-display">{option.displayDate}</div>
            <div className="date-price">${option.price}</div>
            {option.savings > 0 && (
              <div className="date-savings">Save ${option.savings}</div>
            )}
          </button>
        ))}
      </div>
    </div>
  );
};

export default DatePriceExplorer;